module.exports = __webpack_public_path__ + "static/design02-320c159f792b7a9be54b05958a40a51d.jpg";